import { DrawerFooter as ChakraDrawerFooter } from '@chakra-ui/react'

import { DrawerFooterProps } from './DrawerFooter.types'

export default function DrawerFooter(props: DrawerFooterProps) {
  return <ChakraDrawerFooter {...props} translate="no" />
}
